<div
  class="btn-toolbar justify-content-between"
  [ngClass]="changeHeaderColor()"
  role="toolbar"
  aria-label="Toolbar with button groups"
  >
  <div class="btn-group" role="group" aria-label="First group">
    @if (app.header.showSidebar) {
      <button
        class="btn btn-toggle header-sidebar-toggle"
        (click)="app.header.toggleSidebar()"
        >
        <i class="fal fa-chevron-double-left icon-toggle"></i>
      </button>
    }
    @if (!app.header.showSidebar) {
      <button
        class="btn btn-toggle header-sidebar-toggle"
        (click)="app.header.toggleSidebar()"
        >
        <i class="fal fa-chevron-double-right icon-toggle"></i>
      </button>
    }
    <div class="input-group">
      <div class="input-group-prepend">
        <div
          class="header ps-1 ms-1"
          id="header"
          [ngClass]="{ 'small-header': displayFeatures }"
          >
          <span>
            {{ app.header.headerTitle }}
          </span>
        </div>
        @if (displayFeatures) {
          <div
            class="header"
            [ngClass]="{ 'small-header': displayFeatures }"
            >
            <span class="d-md-block ms-lg-2 d-lg-inline-block ms-lg-0">
              {{ app.text.sidebar.poweredBy }}
              <img
                class="z2DataLogo pointer"
                src="./../assets/z2data-logo.png"
                (click)="app.routing.openInNewTab('https://www.z2data.com/')"
                />
              {{ app.text.sidebar.and }}
              <img
                class="lcmLogo pointer"
                src="./../assets/lcm-client-logo-rgb.png"
                (click)="app.routing.openInNewTab('https://lcm-client.com')"
                />
            </span>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="btn-group" role="group" aria-label="third-button-group">
    @if (
      app.permission.thread.hasPermissionToCreateThread && app.view === 'home'
      ) {
      <div
        class="mx-2 mt-1"
        [ngClass]="{ active: app.thread.isNew && app.view === 'thread' }"
        >
        @if (app.permission.thread.hasPermissionToCreateThread) {
          <button
            class="btn btn-sm btn-default-red mt-2"
            (click)="app.clearModel(); navigateNewThread()"
            [disabled]="app.unlockedId != null"
            >
            <i class="fas fa-folder-plus"></i>&nbsp;
            {{ app.text.thread.newCase }}
          </button>
        }
      </div>
    }
    @if (app.view === 'users') {
      <div class="mx-2 mt-1">
        <button
          class="btn btn-sm btn-clean mt-2"
          (click)="app.users.exportData()"
          >
          <i class="fa fa-download"></i>&nbsp; {{ app.text.post.export }}
        </button>
      </div>
    }
    @if (showAddUserBtn && !app.users.creationOpen) {
      <div class="mx-2 mt-1">
        <button
          class="btn btn-sm btn-default-orange mt-2"
          (click)="app.users.initCreation()"
          >
          <!-- (click)="app.routing.navigateNewUser()" -->
          <i class="fa fa-plus"></i>&nbsp; {{ app.text.user.add }}
        </button>
      </div>
    }
    @if (app.view === 'dashboard') {
      <div class="mx-4 mt-3">
        @if (!(app.state.isAnalyst || app.state.isRMAdmin)) {
          <button
            class="btn btn-sm btn-default-red"
            (click)="app.filterDashboard.isOpen = !app.filterDashboard.isOpen"
            [ngClass]="{ btnFilterOpen: app.filterDashboard.isOpen }"
            >
            <i class="fas fa-filter"></i>
            {{ app.text.home.filters }}
            @if (!app.filterDashboard.isOpen) {
              <i class="fal fa-angle-right"></i>
            }
            @if (app.filterDashboard.isOpen) {
              <i class="far fa-times ms-1"></i>
            }
          </button>
        }
      </div>
    }
  </div>
</div>
